"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckIsPasswordConfiguredResponse = exports.GetUsersSummaryResponse = exports.UserAuthenticateResponse = exports.UpdateUserResponse = exports.RestoreUserResponse = exports.DeleteUsersResponse = exports.GetUserResponse = exports.GetCertifiedTrainingIdsResponse = exports.GetUserInfoResponse = exports.NotifyUserCreatedResponse = exports.CreateUserResponse = void 0;
class CreateUserResponse {
}
exports.CreateUserResponse = CreateUserResponse;
class NotifyUserCreatedResponse {
}
exports.NotifyUserCreatedResponse = NotifyUserCreatedResponse;
class GetUserInfoResponse {
}
exports.GetUserInfoResponse = GetUserInfoResponse;
class GetCertifiedTrainingIdsResponse {
}
exports.GetCertifiedTrainingIdsResponse = GetCertifiedTrainingIdsResponse;
class GetUserResponse {
}
exports.GetUserResponse = GetUserResponse;
class DeleteUsersResponse {
}
exports.DeleteUsersResponse = DeleteUsersResponse;
class RestoreUserResponse {
}
exports.RestoreUserResponse = RestoreUserResponse;
class UpdateUserResponse {
}
exports.UpdateUserResponse = UpdateUserResponse;
class UserAuthenticateResponse {
}
exports.UserAuthenticateResponse = UserAuthenticateResponse;
class GetUsersSummaryResponse {
}
exports.GetUsersSummaryResponse = GetUsersSummaryResponse;
class CheckIsPasswordConfiguredResponse {
}
exports.CheckIsPasswordConfiguredResponse = CheckIsPasswordConfiguredResponse;
//# sourceMappingURL=user.js.map